// C:\Users\QI\komondi-dashboard\src\pages\AllUsersPage.js
import React, { useEffect, useState, useMemo } from "react";
import { db } from "./firebase";
import { ref, onValue, set } from "firebase/database";
import { useNavigate } from "react-router-dom";

export default function AllUsersPage() {
  const [users, setUsers] = useState([]);
  const [filterType, setFilterType] = useState("all");
  const [filterDate, setFilterDate] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const usersRef = ref(db, "users");
    const unsub = onValue(usersRef, (snap) => {
      const val = snap.val();
      if (!val) return setUsers([]);
      const arr = Object.keys(val).map((key) => ({
        id: key,
        ...val[key],
      }));
      setUsers(arr);
    });
    return () => unsub();
  }, []);

 const filteredUsers = useMemo(() => {
  return users
    .filter((u) => {
      const matchType =
        filterType === "all" ||
        (u.userType && u.userType.toLowerCase() === filterType.toLowerCase());

      const matchDate =
        !filterDate ||
        (u.registrationDate && u.registrationDate.startsWith(filterDate));

      return matchType && matchDate;
    })
    .sort((a, b) => {
      const parseDate = (val) => {
        if (!val) return 0;
        const fixed = val.replace("\n", "T");
        return new Date(fixed).getTime();
      };

      return parseDate(b.registrationDate) - parseDate(a.registrationDate);
    });
}, [users, filterType, filterDate]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const d = new Date(dateString);
      if (isNaN(d)) return dateString;
      return d.toISOString().slice(0, 10);
    } catch {
      return dateString;
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 15, marginBottom: 20 }}>
        <button
          onClick={() => navigate("/")}
          style={{
            padding: "8px 16px",
            background: "#e5e7eb",
            border: "none",
            borderRadius: 6,
            cursor: "pointer"
          }}
        >
          ← Back to Dashboard
        </button>
        <h2 style={{ margin: 0 }}>All Users ({filteredUsers.length})</h2>
      </div>

      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          style={{ padding: 8 }}
        >
          <option value="all">All Types</option>
          <option value="client">Clients</option>
          <option value="professional">Professionals</option>
          <option value="vendeur">Vendeurs</option>
          <option value="admin">Admins</option>
        </select>

        <input
          type="date"
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
          style={{ padding: 8 }}
        />

        <button onClick={() => { setFilterType("all"); setFilterDate(""); }}>
          Reset
        </button>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#f3f4f6" }}>
            <th style={th}>Image</th>
            <th style={th}>Trade Name</th>
            <th style={th}>Email</th>
            <th style={th}>Phone</th>
            <th style={th}>User Type</th>
            <th style={th}>Registration Date</th>
            <th style={th}>Address</th>
            <th style={th}>Active</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((u) => (
            <tr key={u.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
              <td style={td}>
                <img
                  src={u.imageUrl || "https://via.placeholder.com/40"}
                  alt=""
                  width={40}
                  height={40}
                  style={{ borderRadius: "50%" }}
                />
              </td>
              <td style={td}>{u.tradeName || u.name || "-"}</td>
              <td style={td}>{u.email}</td>
              <td style={td}>{u.phone}</td>
              <td style={td}>{u.userType}</td>
              <td style={td}>{formatDate(u.registrationDate)}</td>
              <td style={td}>{u.adresse || "-"}</td>
              <td style={td}>
                <input
                  type="checkbox"
                  checked={u.active !== false}
                  onChange={async (e) => {
                    try {
                      const userRef = ref(db, `users/${u.id}/active`);
                      await set(userRef, e.target.checked);
                    } catch (err) {
                      console.error("Error updating active:", err);
                    }
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {filteredUsers.length === 0 && <p style={{ marginTop: 10 }}>No users found.</p>}
    </div>
  );
}

const th = { textAlign: "left", padding: 12, fontSize: "14px" };
const td = { padding: 12, fontSize: "14px" };